import { Radar, RadarChart, PolarGrid, PolarAngleAxis, ResponsiveContainer, PolarRadiusAxis } from "recharts";
import { COMPETENCY_ORDER, COMPETENCY_LABELS } from "../lib/scoring";

export function CompetencyRadar({ competencies, height = 280 }) {
  const data = COMPETENCY_ORDER.map((k) => ({
    subject: COMPETENCY_LABELS[k],
    value: competencies?.[k] ?? 0,
  }));
  return (
    <ResponsiveContainer width="100%" height={height}>
      <RadarChart data={data} outerRadius="72%">
        <PolarGrid stroke="#E2E8F0" />
        <PolarAngleAxis dataKey="subject" tick={{ fill: "#475569", fontSize: 11, fontWeight: 600 }} />
        <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
        <Radar dataKey="value" stroke="#0055FF" strokeWidth={2} fill="#0055FF" fillOpacity={0.18} />
      </RadarChart>
    </ResponsiveContainer>
  );
}
